export const eventContact = () => {
    // ===============================
    // Suivi des clics sur les boutons contact
    // ===============================
    const trackButtons = (selector: string, location: string) => {
        const container = document.querySelector(selector);
        if (!container) return;

        const buttons = container.querySelectorAll('.btn-contact') as NodeListOf<HTMLElement>;
        buttons.forEach(button => {
            button.addEventListener('click', () => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    emplacementCTA: location,
                    event: 'ctaContact'
                });
            });
        });
    };

    trackButtons('header', 'Header');
    trackButtons('footer', 'Footer');
    trackButtons('section.block', 'Contenu');
};
